export const mypage = {
  heading: '마이페이지',
  logout: '로그아웃',

  // 섹션 제목
  nextLessonTitle: '다음 레슨',
  planTitle: '플랜·잔여 횟수',
  pastLessonsTitle: '지난 레슨',
  profileTitle: '프로필',
  menuTitle: '메뉴',

  // 다음 레슨
  joinMeet: 'Google Meet 참가하기',
  sendNextSchedule: '다음 레슨 일정을 보내주세요',
  sendPreferred: '희망 일시 보내기 →',
  waitingMatch: '매칭 대기 중입니다. 확정되면 이메일로 안내드립니다.',
  partner: '상대：',

  // 플랜·잔여 횟수
  noPlan: '플랜에 등록하면 레슨을 받을 수 있습니다',
  viewPlans: '플랜 보기 →',
  remainingLessons: '잔여 레슨 수',
  rolloverLessons: '이월 횟수',
  nextRenewal: '다음 갱신：',
  planLabels: {
    basic: '베이직(월 4회)',
    plus2: '플러스2(월 6회)',
    plus4: '플러스4(월 8회)',
  },
  subscriptionStatus: {
    none: '미등록',
    active: '활성',
    paused: '일시정지 중',
    cancelled: '해지됨',
    past_due: '결제 확인 중',
  },

  // 지난 레슨
  fillForm: '폼 작성하기 →',

  // 프로필
  name: '이름',
  email: '이메일',
  country: '거주 국가',
  timezone: '시간대',
  nativeLanguages: '모국어',
  learningLanguages: '학습 언어',
  editProfile: '프로필 편집 →',

  // 메뉴
  menu: {
    curriculum: '🗺️ 커리큘럼 진행도',
    schedule: '📅 레슨 희망 일시 보내기',
    plans: '💳 플랜 선택·변경',
    wordPool: '📖 Word Pool',
    addWord: '✏️ 단어 등록',
    postLesson: '📝 레슨 후 폼',
    levelCheck: '🎯 레벨 체크',
    additionalLesson: '➕ 추가 레슨 신청',
    contact: '📬 문의하기',
    orgSchedule: '👥 단체 스케줄',
    adminDashboard: '🛠️ 운영 대시보드',
    adminMatching: '🔧 매칭 관리',
    adminWordPool: '🔧 Word Pool 승인',
    adminLevelCheck: '🔧 레벨 체크 결과',
  },
};
